import { useEffect } from "react"
import Cookies from 'js-cookie';
import { LoadingIcon, Modal } from "@prosolve/common-components-ui"
import TrainerCompensationCard from "../TrainerDashboard/TrainerCompensationCard"
import useDataTrainers from "../../dataHooks/useDataTrainers"

export default ({
  eventData,
  onClose
}) => {
  const userId = Cookies.get('loggedInUserId');

  const {
    id
  } = eventData

  const { isLoading, trainerEventCompensation, fetchTrainerEventCompensation } = useDataTrainers()

  const {
    id: trainerEventCompensationId
  } = trainerEventCompensation || {}

  useEffect(() => {
    fetchTrainerEventCompensation(userId, id)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal title='My Comp' isAutoHeight={true} isAutoWidth={true} onClose={onClose}>
      {
        isLoading 
        ?
        <div style={{ width: '600px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
        :
        !trainerEventCompensationId
        ?
        <div style={{ width: '600px', textAlign: 'center', padding: '30px', border: 'solid 1px silver', borderRadius: '5px' }}>
          No Compensation Data Found
        </div>
        :
        <TrainerCompensationCard compensationData={trainerEventCompensation} variant='eventCompensation' />
      }
    </Modal>
  )
}